import LandingPage, { type LandingPageData } from "./landing";
import { landingContent } from "@shared/landing-content";

const data: LandingPageData = {
  path: "/tiktok-ads-bureau",
  seo: {
    nl: {
      title: "TikTok Ads Bureau voor E-commerce | Wrkt Digital",
      description: "Wrkt Digital helpt D2C e-commerce merken groeien met TikTok Ads. AI-gedreven creative strategie, hook frameworks en campagnebeheer voor webshops met ambitie.",
      keywords: "TikTok Ads bureau Nederland, TikTok adverteren webshop, TikTok Ads e-commerce, TikTok advertising agency, TikTok bureau Amsterdam, TikTok ads D2C, tiktok ads, tiktok advertising, ads tiktok, tik tok ads, tiktok ads uitbesteden, adverteren op tiktok uitbesteden, tiktok shop",
    },
    en: {
      title: "TikTok Ads Agency for E-commerce | Wrkt Digital",
      description: "Wrkt Digital helps D2C e-commerce brands grow with TikTok Ads. AI-driven creative strategy, hook frameworks, and campaign management for ambitious webshops.",
      keywords: "TikTok Ads agency Netherlands, TikTok advertising webshop, TikTok Ads e-commerce, TikTok advertising agency Amsterdam, TikTok ads D2C, tiktok ads, tiktok advertising, ads tiktok, outsource tiktok ads, tiktok shop",
    },
  },
  content: landingContent["/tiktok-ads-bureau"],
};

export default function LandingTikTokAds() {
  return <LandingPage data={data} />;
}
